// ULTRA UNIQUE Experimental SoundManager
class ExperimentalSoundManager {
  private context: AudioContext | null = null;
  
  private initContext() {
    if (!this.context) {
      this.context = new AudioContext();
    }
    return this.context;
  }

  // Download - Cyber cascade
  download() {
    const ctx = this.initContext();
    this.playTone(1500, 0.05, 'square', 0.2, ctx);
    setTimeout(() => this.playTone(1000, 0.04, 'square', 0.2, ctx), 50);
    setTimeout(() => this.playTone(500, 0.06, 'square', 0.2, ctx), 100);
    setTimeout(() => this.playTone(300, 0.08, 'square', 0.2, ctx), 160);
  }

  // Save - Crystal lock
  save() {
    const ctx = this.initContext();
    this.playTone(600, 0.1, 'sine', 0.3, ctx);
    setTimeout(() => this.playTone(800, 0.08, 'sine', 0.3, ctx), 120);
    setTimeout(() => this.playTone(1000, 0.12, 'sine', 0.35, ctx), 240);
  }

  // Sign-in - Portal entrance
  signIn() {
    const ctx = this.initContext();
    this.playTone(400, 0.1, 'sine', 0.3, ctx);
    setTimeout(() => this.playTone(600, 0.1, 'sine', 0.3, ctx), 120);
    setTimeout(() => this.playTone(800, 0.15, 'sine', 0.35, ctx), 240);
    setTimeout(() => this.playTone(1000, 0.2, 'sine', 0.4, ctx), 400);
  }

  // Theme toggle - Reality warp
  themeToggle() {
    const ctx = this.initContext();
    this.playTone(300, 0.05, 'sawtooth', 0.25, ctx);
    setTimeout(() => this.playTone(500, 0.04, 'sawtooth', 0.25, ctx), 60);
    setTimeout(() => this.playTone(700, 0.06, 'sine', 0.3, ctx), 120);
  }

  // Resume delete - Digital decay
  resumeDelete() {
    const ctx = this.initContext();
    this.playTone(400, 0.1, 'sawtooth', 0.35, ctx);
    setTimeout(() => this.playTone(300, 0.1, 'sawtooth', 0.35, ctx), 120);
    setTimeout(() => this.playTone(200, 0.15, 'sawtooth', 0.4, ctx), 240);
    setTimeout(() => this.playTone(100, 0.2, 'sawtooth', 0.35, ctx), 400);
  }

  // Resume complete - Victory fanfare
  resumeComplete() {
    const ctx = this.initContext();
    this.playTone(523.25, 0.1, 'sine', 0.3, ctx);
    setTimeout(() => this.playTone(659.25, 0.1, 'sine', 0.3, ctx), 120);
    setTimeout(() => this.playTone(783.99, 0.1, 'sine', 0.35, ctx), 240);
    setTimeout(() => this.playTone(1046.50, 0.15, 'sine', 0.4, ctx), 360);
    setTimeout(() => this.playTone(1318.51, 0.2, 'sine', 0.45, ctx), 520);
    setTimeout(() => this.playTone(1567.98, 0.25, 'sine', 0.5, ctx), 700);
  }

  // Error sound - Low descending tone
  error() {
    const ctx = this.initContext();
    this.playTone(400, 0.1, 'sawtooth', 0.3, ctx);
    setTimeout(() => this.playTone(300, 0.15, 'sawtooth', 0.25, ctx), 100);
  }

  // Message sent - Quick success chirp
  messageSent() {
    const ctx = this.initContext();
    this.playTone(800, 0.08, 'sine', 0.3, ctx);
    setTimeout(() => this.playTone(1000, 0.1, 'sine', 0.35, ctx), 80);
  }

  private playTone(frequency: number, duration: number, type: OscillatorType, volume: number, ctx: AudioContext) {
    try {
      if (ctx.state === 'suspended') ctx.resume();
      
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.frequency.value = frequency;
      oscillator.type = type;
      
      gainNode.gain.setValueAtTime(0, ctx.currentTime);
      gainNode.gain.linearRampToValueAtTime(volume, ctx.currentTime + 0.02);
      gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
      
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + duration);
    } catch (error) {
      console.log('Sound play failed:', error);
    }
  }
}

// Use this line for experimental sounds:
export const soundManager = new ExperimentalSoundManager();